import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetomumbaibushire() {


const cardData = {
keyword: "Pune to Mumbai Bus Hire for Tour Package From Pune",
headingDescription: "Ruturaj Enterprises provides Pune to Mumbai Bus Hire for Tour Package From Pune for families, friends, corporate teams, tourists, wedding groups, and organized travel parties. AC, luxury, and suitable-capacity buses can be arranged for Mumbai sightseeing, one-day tours, weekend trips, airport transfers, corporate travel, wedding transportation, and round-trip journeys. Groups can plan convenient Pune pickup points, Mumbai sightseeing stops, travel timings, breaks, and return schedules according to their itinerary and passenger requirements.",
topPlaces: [
{
title: "Gateway of India",
description: "Gateway of India is one of Mumbai's most recognizable waterfront landmarks and a popular stop for visitors exploring South Mumbai. A dedicated tour bus allows families and groups to include this iconic attraction in a convenient Mumbai sightseeing itinerary."
},
{
title: "Marine Drive",
description: "Marine Drive is a famous Mumbai promenade known for its coastal views and evening atmosphere. Groups visiting Mumbai from Pune can include Marine Drive in a one-day or weekend sightseeing plan while traveling together in a dedicated bus."
},
{
title: "Chhatrapati Shivaji Maharaj Terminus",
description: "Chhatrapati Shivaji Maharaj Terminus is a historic railway landmark featuring distinctive heritage architecture in central Mumbai. It is a popular destination for tourists and heritage enthusiasts and can be included as part of a structured city sightseeing route."
},
{
title: "Siddhivinayak Temple",
description: "Siddhivinayak Temple is a prominent religious destination in Mumbai visited by devotees throughout the year. Families and pilgrimage groups traveling from Pune can include the temple in their itinerary along with other Mumbai attractions."
},
{
title: "Bandra-Worli Sea Link",
description: "Bandra-Worli Sea Link is a major Mumbai landmark connecting the western suburbs across Mahim Bay. Tourists traveling from Pune can experience the structure while moving between popular sightseeing areas during a planned city tour."
},
{
title: "Juhu Beach",
description: "Juhu Beach is a popular Mumbai destination for families, tourists, and groups looking for a relaxed coastal outing. It can be included in a full-day Mumbai tour along with nearby attractions and dining stops."
},
{
title: "Elephanta Caves",
description: "Elephanta Caves are an important historical and cultural attraction located on Elephanta Island near Mumbai. Groups can include a visit to the caves in a broader Mumbai sightseeing itinerary while using dedicated bus transportation for their city travel."
},
{
title: "Sanjay Gandhi National Park",
description: "Sanjay Gandhi National Park offers a large green space within Mumbai and is popular with nature lovers and families. It can be added to an extended city sightseeing program for groups looking to combine urban attractions with a natural environment."
},
{
title: "Colaba Causeway",
description: "Colaba Causeway is a well-known shopping and leisure area in South Mumbai surrounded by several tourist landmarks. A group bus makes it convenient to include Colaba in an itinerary covering Gateway of India and other South Mumbai attractions."
},
{
title: "Bandra Fort",
description: "Bandra Fort is a historic waterfront structure offering views toward the Arabian Sea and Bandra-Worli Sea Link. It can be included as an additional sightseeing stop for groups planning a western Mumbai tour from Pune."
}
],
services: [
{
name: "Pune to Mumbai Bus Tour Package",
description: "Pune to Mumbai Bus Tour Package provides dedicated transportation for families, tourists, friends, corporate groups, and organized travel parties. The itinerary can be planned around Mumbai sightseeing, meal breaks, shopping stops, major landmarks, and convenient return travel."
},
{
name: "Pune Mumbai Bus Hire",
description: "Pune Mumbai Bus Hire is suitable for groups traveling together from Pune to Mumbai for sightseeing, events, business programs, weddings, and family outings. A dedicated bus simplifies group coordination while allowing the journey to follow a planned schedule."
},
{
name: "Pune Mumbai Bus Rental",
description: "Pune Mumbai Bus Rental offers a practical transportation solution for groups requiring dedicated travel between the two cities. Vehicle capacity, AC preference, travel duration, passenger count, luggage requirements, and sightseeing plans can be considered while organizing the trip."
},
{
name: "Pune Mumbai Bus Booking",
description: "Pune Mumbai Bus Booking allows groups to arrange their travel vehicle according to their planned Mumbai visit. Pickup location, passenger strength, preferred bus category, departure timing, sightseeing requirements, and return schedule can be considered during the booking process."
},
{
name: "Mumbai Tour Package from Pune by Bus",
description: "Mumbai Tour Package from Pune by Bus is designed for travelers who want to explore major Mumbai attractions using common group transportation. The itinerary can include heritage landmarks, beaches, temples, shopping areas, waterfront destinations, and other selected places."
},
{
name: "Pune Mumbai AC Bus Hire",
description: "Pune Mumbai AC Bus Hire provides a comfortable travel option for groups making the journey between Pune and Mumbai. Air-conditioned transportation is suitable for families, tourists, corporate teams, wedding groups, and passengers planning a full-day sightseeing program."
},
{
name: "Luxury Bus for Mumbai Tour Pune",
description: "Luxury Bus for Mumbai Tour Pune is suitable for groups seeking a premium travel environment for their Mumbai excursion. It can be considered for corporate travel, family holidays, special occasions, wedding groups, and organized tours where enhanced comfort is preferred."
},
{
name: "Pune Mumbai Tourist Bus",
description: "Pune Mumbai Tourist Bus provides organized transportation for visitors exploring Mumbai's popular landmarks and cultural destinations. Groups can create an itinerary covering South Mumbai, western suburbs, beaches, temples, heritage locations, and other tourist attractions."
},
{
name: "Pune Mumbai Group Tour Bus",
description: "Pune Mumbai Group Tour Bus is ideal for friends, relatives, community groups, student groups, and organized tourist parties. Traveling in one dedicated vehicle keeps the group together and makes it easier to coordinate sightseeing stops and departure timings."
},
{
name: "Pune Mumbai Family Tour Bus",
description: "Pune Mumbai Family Tour Bus provides convenient transportation for families planning a Mumbai holiday or day trip. The itinerary can include beaches, temples, heritage landmarks, shopping areas, and family-friendly attractions while keeping everyone together throughout the journey."
},
{
name: "Pune Mumbai One Day Tour Bus",
description: "Pune Mumbai One Day Tour Bus is suitable for groups planning a same-day Mumbai excursion from Pune. An organized schedule can include an early departure, selected city attractions, meal or rest breaks, leisure time, and a planned return journey."
},
{
name: "Pune Mumbai Round Trip Bus",
description: "Pune Mumbai Round Trip Bus provides transportation for both the onward and return journey between Pune and Mumbai. It is useful for sightseeing tours, family outings, corporate programs, weddings, events, and weekend travel where a common return vehicle is preferred."
},
{
name: "Pune Mumbai Outstation Bus Hire",
description: "Pune Mumbai Outstation Bus Hire is suitable for groups traveling from Pune to Mumbai for an extended city visit, event, tour, or organized program. The vehicle can be arranged according to group size, journey duration, route, sightseeing requirements, and return plans."
},
{
name: "Affordable Pune Mumbai Bus Rental",
description: "Affordable Pune Mumbai Bus Rental provides a practical shared transportation option for groups looking to manage travel expenses efficiently. Choosing a suitable bus capacity can reduce the need for multiple cars while keeping the entire group on a common travel schedule."
},
{
name: "Mumbai Sightseeing Bus from Pune",
description: "Mumbai Sightseeing Bus from Pune allows groups to travel directly from Pune and explore multiple attractions across Mumbai. The itinerary can include landmarks such as Gateway of India, Marine Drive, Juhu Beach, temples, heritage areas, and other preferred destinations."
},
{
name: "Pune Mumbai Corporate Bus Hire",
description: "Pune Mumbai Corporate Bus Hire is suitable for employees and business groups attending meetings, conferences, exhibitions, corporate events, and official programs in Mumbai. A dedicated bus helps teams travel together according to planned office or event schedules."
},
{
name: "Pune Mumbai Airport Bus Service",
description: "Pune Mumbai Airport Bus Service provides group transportation for passengers traveling between Pune and Mumbai Airport. It can be useful for corporate teams, families, tour groups, and other parties requiring coordinated airport transfers with suitable luggage capacity."
},
{
name: "Pune Mumbai Group Transportation",
description: "Pune Mumbai Group Transportation offers a centralized travel solution for large families, tourist parties, corporate teams, wedding groups, schools, and social organizations. A dedicated bus simplifies pickup coordination, route planning, sightseeing movement, and return transportation."
},
{
name: "Pune Mumbai Wedding Bus Rental",
description: "Pune Mumbai Wedding Bus Rental is suitable for transporting relatives, guests, friends, and wedding parties between Pune and Mumbai. Group buses can support wedding functions, ceremonies, receptions, guest transfers, and scheduled movement between accommodation and event venues."
},
{
name: "Pune Mumbai Weekend Tour Bus",
description: "Pune Mumbai Weekend Tour Bus is designed for groups planning a short leisure trip to Mumbai. Travelers can create a flexible weekend itinerary covering beaches, heritage attractions, shopping districts, temples, waterfront areas, and other popular destinations."
},
{
name: "Pune Mumbai AC Tourist Bus",
description: "Pune Mumbai AC Tourist Bus provides a comfortable option for tourists traveling together on a sightseeing itinerary. Air-conditioned group transportation is useful for full-day tours where passengers expect convenient travel between multiple attractions across Mumbai."
},
{
name: "Mumbai Tour Bus Booking Pune",
description: "Mumbai Tour Bus Booking Pune helps groups organize dedicated transportation before their planned Mumbai tour. Travel arrangements can be aligned with passenger numbers, selected bus type, pickup point, sightseeing itinerary, departure timing, and return requirements."
}
],
tableData: [
["Pune to Mumbai Bus Tour Package", "Pune Mumbai Bus Hire"],
["Pune Mumbai Bus Rental", "Pune Mumbai Bus Booking"],
["Mumbai Tour Package from Pune by Bus", "Pune Mumbai AC Bus Hire"],
["Luxury Bus for Mumbai Tour Pune", "Pune Mumbai Tourist Bus"],
["Pune Mumbai Group Tour Bus", "Pune Mumbai Family Tour Bus"],
["Pune Mumbai One Day Tour Bus", "Pune Mumbai Round Trip Bus"],
["Pune Mumbai Outstation Bus Hire", "Affordable Pune Mumbai Bus Rental"],
["Mumbai Sightseeing Bus from Pune", "Pune Mumbai Corporate Bus Hire"],
["Pune Mumbai Airport Bus Service", "Pune Mumbai Group Transportation"],
["Pune Mumbai Wedding Bus Rental", "Pune Mumbai Weekend Tour Bus"],
["Pune Mumbai AC Tourist Bus", "Mumbai Tour Bus Booking Pune"]
],
whychoose: [
{
WhyChooseheading: "Convenient Pune to Mumbai Group Travel",
WhyChoosedescription: "A dedicated bus allows families, friends, tourists, and organized groups to travel together from Pune to Mumbai without coordinating multiple cars. The journey can be structured around convenient pickup points, planned departure times, sightseeing stops, and return requirements."
},
{
WhyChooseheading: "Designed for Mumbai Sightseeing",
WhyChoosedescription: "Mumbai has attractions spread across different parts of the city, making organized transportation useful for group tours. A dedicated bus can support an itinerary covering South Mumbai, western suburbs, beaches, temples, heritage landmarks, and shopping areas."
},
{
WhyChooseheading: "One-Day and Weekend Flexibility",
WhyChoosedescription: "Groups can plan either a same-day Mumbai excursion or a longer weekend visit depending on their schedule. Transportation can be coordinated around sightseeing duration, meal breaks, leisure time, and the preferred return journey."
},
{
WhyChooseheading: "Comfortable AC Travel",
WhyChoosedescription: "AC bus options provide a comfortable environment for groups traveling between Pune and Mumbai and moving between multiple attractions. They are particularly useful for families, tourists, corporate teams, and wedding groups spending several hours on the road."
},
{
WhyChooseheading: "Useful for Corporate Groups",
WhyChoosedescription: "Business teams attending meetings, conferences, exhibitions, and corporate events can benefit from centralized transportation. A common bus helps employees travel together while simplifying coordination between Pune pickup locations and Mumbai destinations."
},
{
WhyChooseheading: "Suitable for Weddings and Events",
WhyChoosedescription: "Wedding parties and event groups often need transportation for several guests traveling on a common schedule. A dedicated bus can support guest transfers between Pune and Mumbai as well as planned movement to functions, hotels, and event venues."
},
{
WhyChooseheading: "Options for Different Group Sizes",
WhyChoosedescription: "Tour groups vary significantly in passenger strength, so transportation can be selected according to the size of the party. Choosing an appropriately sized bus helps keep the group together while providing practical space for passengers and their travel belongings."
},
{
WhyChooseheading: "Simplified Round-Trip Planning",
WhyChoosedescription: "Arranging the Pune-to-Mumbai journey and return transportation together makes the overall trip easier to coordinate. The same planned transportation arrangement can support sightseeing, airport transfers, events, family tours, and weekend travel according to the group's schedule."
}
]
};













const faqData = [
{
question: "Can I hire a bus from Pune to Mumbai for a tour package?",
answer: "A private bus can be hired from Pune for a planned Mumbai tour package, making it suitable for families, friends, corporate groups, school groups, and organized tours. Ruturaj Enterprises can arrange transportation according to the group size, itinerary, luggage requirements, and duration of the tour."
},
{
question: "Is a bus suitable for a Pune to Mumbai group tour?",
answer: "Traveling by a dedicated bus allows the entire group to stay together throughout the Pune to Mumbai journey. It can simplify pickup arrangements, sightseeing coordination, meal breaks, luggage handling, and the return trip while avoiding the need to manage multiple cars."
},
{
question: "Which places can we visit in Mumbai with a tour bus?",
answer: "A Mumbai tour itinerary may include Gateway of India, Marine Drive, Colaba, Chhatrapati Shivaji Maharaj Terminus, Siddhivinayak Temple, Juhu Beach, Bandra, and other attractions. The sightseeing route can be planned according to the group's interests and available travel time."
},
{
question: "Can families book a private bus for a Mumbai tour from Pune?",
answer: "Families traveling with relatives and children can reserve a dedicated bus for a Mumbai tour. Having everyone in one vehicle makes it easier to coordinate sightseeing stops and travel timings while providing a practical solution for carrying luggage during the trip."
},
{
question: "Can corporate groups hire a bus for a Pune to Mumbai tour?",
answer: "Corporate teams can hire a bus for employee outings, business-related group travel, conferences, team activities, and recreational tours in Mumbai. A dedicated vehicle helps the team maintain a common schedule and move between planned locations without arranging separate transportation."
},
{
question: "Can I book an AC bus for a Pune to Mumbai tour package?",
answer: "Groups looking for enhanced comfort can choose an AC bus depending on availability and their travel requirements. Ruturaj Enterprises can help identify a suitable vehicle by considering passenger capacity, journey duration, luggage, sightseeing plans, and the group's preferred comfort level."
},
{
question: "Can the Pune to Mumbai bus be booked for a one-day tour?",
answer: "A one-day private bus package can work well for groups planning selected Mumbai attractions within a limited schedule. The itinerary can be organized around the departure from Pune, sightseeing priorities, planned breaks, and the expected return time."
},
{
question: "Can we rent a bus for a multi-day Mumbai tour from Pune?",
answer: "Multi-day bus rental is useful when a group wants additional time for Mumbai sightseeing, local activities, events, or nearby destinations. The transportation plan can be arranged around overnight stays, daily sightseeing requirements, passenger count, and the complete duration of the tour."
},
{
question: "What seating capacity is suitable for a Pune to Mumbai tour package?",
answer: "The right bus size depends on the number of people traveling and the amount of luggage they will carry. Smaller groups can select a suitable compact option, while larger tour groups can consider higher-capacity buses based on passenger requirements, comfort, and itinerary."
},
{
question: "Why choose Ruturaj Enterprises for a Pune to Mumbai bus hire?",
answer: "Ruturaj Enterprises provides dedicated group transportation for tour packages between Pune and Mumbai. The vehicle choice can be planned around the size of the group, luggage, sightseeing schedule, trip duration, and required comfort, helping travelers manage their complete tour transportation more conveniently."
}
];

const testimonials = [
{
id: 1,
name: "Mr. Kunal Shinde",
feedback:
"Our group hired a bus from Ruturaj Enterprises for a Pune to Mumbai tour package. Having one vehicle for everyone made the sightseeing schedule much easier to manage, and we did not have to coordinate multiple cars. The overall travel arrangement worked very well for our group.",
rating: 5
},
{
id: 2,
name: "Miss. Anjali More",
feedback:
"We planned a Mumbai sightseeing tour with relatives and selected Ruturaj Enterprises for our bus rental from Pune. The dedicated vehicle allowed everyone to stay together during the journey and visit the places on our itinerary conveniently. It was a comfortable option for our group tour.",
rating: 5
}
];








































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "Tempo-Traveller-On-Rent-in-Pune" },
        { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller on Rent", link: "Pune-to-Shirdi-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "Pune-to-Mahabaleshwar-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller", link: "Pune-to-Goa-Tempo-Traveller" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "Pune-to-Mumbai-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/6.jpg", text: "Pune to Konkan Tempo Traveller", link: "Pune-to-Konkan-Tempo-Traveller" },
        { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "Pune-to-Nashik-Tempo-Traveller-On-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller On Rent", link: "Pune-Darshan-Tempo-Traveller-On-Rent" },
        { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller on Rent", link: "13-Seater-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-Seater-Tempo-Traveller-on-Rent-in-Pune" },
        { place: "/images/keyword/12.jpg", text: "20 Seater Bus on Rent in Pune", link: "20-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller on Rent in Pune", link: "26-Seater-Tempo-Traveller-on-Rent-in-Pune" },
        { place: "/images/keyword/14.jpg", text: "32 Seater Bus Rent in Pune", link: "32-Seater-Bus-Rent-in-Pune" },
        { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/16.jpg", text: "45 Seater Bus on Rent in Pune", link: "45-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-Seater-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/18.jpg", text: "Bus Rentals For School Trips in Pune", link: "Bus-Rentals-For-School-Trips-in-Pune" },
        { place: "/images/keyword/19.jpg", text: "Bus booking for wedding in Pune", link: "Bus-booking-for-wedding-in-Pune" },
        { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage", link: "Bus-Booking-for-Marriage" },
        { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate Pune", link: "Bus-Service-for-Corporate-Pune" },
        { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "Bus-on-Rent-For-Event-in-Pune" },
        { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation", link: "Bus-Hire-for-Outstation" },
        { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "AC-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "Pune-Bus-Hire-Rental-Service" },
    ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mumbai Bus Hire for Tour Package From Pune",
  "image": "https://ruturajenterprises.com/assets/images/pune-to-mumbai-bus-hire-for-tour-package-from-pune.webp",
  "description":
    "Pune to Mumbai Bus Hire for Tour Package From Pune for family holidays, group tours, corporate travel, weekend trips, events, and sightseeing. Ruturaj Enterprises provides comfortable AC and luxury buses from Pune to Mumbai with suitable seating capacities, experienced drivers, convenient pickup arrangements, and flexible rental plans. The service is suitable for Mumbai city tours, business travel, group outings, airport transfers, and visits to popular destinations around Mumbai.",
  "brand": {
    "@type": "Brand",
    "name": "Ruturaj Enterprises"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://ruturajenterprises.com/pune-to-mumbai-bus-hire-for-tour-package-from-pune"
  }
};







    return (
        <div>

<Helmet>
  <title>
    Pune to Mumbai Bus Hire for Tour Package From Pune | Pune Mumbai Bus Hire | +91 9763381382
  </title>

  <meta
    name="description"
    content="Pune to Mumbai Bus Hire for Tour Package From Pune for family trips, group tours, corporate travel, weekend outings and sightseeing. Hire comfortable AC and luxury buses from Pune to Mumbai with flexible rental options."
  />

  <meta
    name="keywords"
    content="Pune to Mumbai Bus Tour Package, Pune Mumbai Bus Hire, Pune Mumbai Bus Rental, Pune Mumbai Bus Booking, Mumbai Tour Package from Pune by Bus, Pune Mumbai AC Bus Hire, Luxury Bus for Mumbai Tour Pune, Pune to Mumbai Tourist Bus, Mumbai Sightseeing Bus from Pune, Pune Mumbai Group Tour Bus, Pune Mumbai Family Tour Bus, Pune Mumbai One Day Tour Bus, Pune Mumbai Weekend Tour Bus, Pune to Mumbai Bus Rental, Pune to Mumbai Bus Hire, Pune to Mumbai Bus Booking, Pune to Mumbai AC Bus Rental, Pune to Mumbai Luxury Bus Rental, Pune to Mumbai Group Bus Rental, Pune to Mumbai Family Bus Rental, Pune to Mumbai One Day Bus Rental, Pune to Mumbai Weekend Bus Rental, Pune Mumbai Tourist Bus Rental, Pune Mumbai Tour Bus Service, Mumbai Bus Tour Package Pune, Mumbai Bus Rental from Pune, Mumbai Bus Hire from Pune, Mumbai Bus Booking from Pune, Mumbai Holiday Bus Package Pune, Mumbai Family Tour Package Pune, Mumbai Group Tour Package Pune, Mumbai Weekend Trip Bus Pune, Mumbai One Day Trip Bus Pune, Mumbai Corporate Tour Bus Pune, Mumbai Corporate Outing Bus Pune, Mumbai Business Travel Bus Pune, Mumbai Airport Transfer Bus Pune, Mumbai Event Bus Rental Pune, Mumbai Wedding Guest Bus Pune, Mumbai Picnic Bus Rental Pune, Mumbai Sightseeing Bus Rental Pune, Pune to Mumbai Bus for Family Trip, Pune to Mumbai Bus for Group Travel, Pune to Mumbai Bus for Corporate Trip, Pune to Mumbai Bus for Wedding, Pune to Mumbai Bus for Picnic, Pune to Mumbai Bus for School Trip, Pune to Mumbai Bus for College Trip, Pune to Mumbai Outstation Bus Rental, Pune to Mumbai Outstation Bus Hire, AC Bus on Rent Pune to Mumbai, Luxury Bus on Rent Pune to Mumbai, Tourist Bus Pune to Mumbai, Group Bus Pune to Mumbai, Family Bus Pune to Mumbai, 20 Seater Bus Pune to Mumbai, 32 Seater Bus Pune to Mumbai, 35 Seater Bus Pune to Mumbai, 45 Seater Bus Pune to Mumbai, 50 Seater Bus Pune to Mumbai, Pune Mumbai City Tour Bus, Pune Mumbai Gateway of India Tour Bus, Pune Mumbai Marine Drive Tour Bus, Pune Mumbai Juhu Beach Tour Bus, Pune Mumbai Elephanta Tour Bus, Pune Mumbai Lonavala Mumbai Tour Bus, Affordable Pune to Mumbai Bus Rental, Ruturaj Enterprises Pune Mumbai Bus Service"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <div
                className="ltn__breadcrumb-area ltn__breadcrumb-area-2 ltn__breadcrumb-color-white bg-overlay-theme-black-90 bg-image"
                style={{ backgroundImage: "url('/img/bg/9.jpg')" }}
            >
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="ltn__breadcrumb-inner ltn__breadcrumb-inner-2 justify-content-between">
                                <div className="section-title-area ltn__section-title-2">
                                    <h1 className="section-title white-color">
                                        {cardData.keyword}
                                    </h1>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </div>






















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/41.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Ruturaj Enterprises: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">

                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable /> */}

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Ruturaj Enterprises</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Ruturaj Enterprises </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                {/* <FleetHighway /> */}
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919763381382" className="pc-call">+91 9763381382</a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919011051114" className="pc-call">+91 9011051114</a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919822697554" className="pc-call">+91 9822697554</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919763381382"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919763381382" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@ruturajenterprises.com" className="pc-email">
                                            booking@ruturajenterprises.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Ruturaj Enterprises</strong><br />

                                            Nandini Takle Nagar, Pune - Solapur Road Manjri Bk Hadapsar, Pune, Maharashtra 412307
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetomumbaibushire ;